<template>
  <div v-if="!htmlText && !img">
    <p v-if="title" v-html="title" class="font-weight-bold mb-1"></p>
    <p v-if="text" v-html="text"></p>
  </div>
  <div v-else-if="img" class="mb-10">
    <v-img :src="img"/>
  </div>
  <div v-else v-html="htmlText"></div>
</template>

<script>
export default {
  name: 'PalyazatContentItem',
  props: {
    title: {
      type: String,
      default() {
        return 'mb-4';
      },
    },
    text: {
      type: String,
      default() {
        return 'mb-4';
      },
    },
    img: {
      type: String,
      default() {
        return null;
      },
    },
    htmlText: {
      type: String,
      default() {
        return '';
      },
    },
    useP: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
};
</script>

<style scoped>

</style>
